import { Box, Button, ListItem, ListItemButton, ListItemText, Stack } from "@mui/material";
import Grid from "@mui/material/Grid";
import { formatDate } from "../../utils/dateTimeFormat";
import Translate from "../../utils/Translate";
import { ScatterPlot } from "@mui/icons-material";

function StUnitListItemField({ label, value }) {
  return (
    <Grid container size={12}>
      <Grid className="stUnitListItemFieldLabel" size={6}>
        {label}:
      </Grid>
      <Grid size={6}>
        {value}
      </Grid>
    </Grid>
  );
}

export default function StUnitListItem({
  isUnlimitedQty,
  qty,
  revision,
  locationAreaName,
  bestBeforeDate,
  printing,
  fifoDate,
  selected,
  onSelect,
  disabled,
}) {
  return (
    <ListItem
      disablePadding
      className={"stUnitListItem" + (selected ? " selected" : "") + (disabled ? " disabled" : "")}
    >
      <ListItemButton disabled={disabled} onClick={onSelect}>
        <ListItemText>
          <Grid container direction="column" size={12}>
            <Grid container size={12}>
              <Grid size={6}>
                <StUnitListItemField label={Translate.get("Quantity")} value={isUnlimitedQty ? "∞" : qty} />
              </Grid>
              <Grid size={6}>
                <StUnitListItemField label={Translate.get("StUnitAreaLabel")} value={locationAreaName ?? "-"} />
              </Grid>
            </Grid>
            <Grid container size={12}>
              <Grid size={6}>
                <StUnitListItemField label={Translate.get("StUnitRevisionLabel")} value={revision ?? "-"} />
              </Grid>
              <Grid size={6}>
                <StUnitListItemField label={Translate.get("StUnitPrintingLabel")} value={printing ?? "-"} />
              </Grid>
            </Grid>
            <Grid container size={12}>
              <Grid size={6}>
                <StUnitListItemField
                  label={Translate.get("StUnitBestBeforeDate")}
                  value={bestBeforeDate ? formatDate(bestBeforeDate) : "-"}
                />
              </Grid>
              <Grid size={6}>
                <StUnitListItemField
                  label={Translate.get("StUnitFifoDate")}
                  value={fifoDate ? formatDate(fifoDate) : "-"}
                />
              </Grid>
            </Grid>
          </Grid>
        </ListItemText>
      </ListItemButton>
    </ListItem>
  );
}
